import { useContext } from 'react';
import { SiteSettingsContext } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { freeSpinAggregatedStatusesMap } from '../../constants';
import { useFreeSpinBonusActions } from '../../hooks/useFreeSpinBonusActions';
import { useFreeSpinBonus } from '../../store';
import { BonusCard } from '../BonusCard';

export const FreeSpinBonusCard = ({ bonusId, onAccept, onWagerAccept }) => {
  const { t, language } = useI18n();
  const bonus = useFreeSpinBonus(bonusId);
  const [settings] = useContext(SiteSettingsContext);
  const { otherSettings = {} } = settings || {};
  const { bonuses = {} } = otherSettings;
  const { isShowMultilangImages = false } = bonuses;
  const { acceptFreeSpin, openDetails, isRequestProcessing } =
    useFreeSpinBonusActions({ bonus, onAccept, onWagerAccept });
  const {
    state,
    imageUrl,
    bonusModelId,
    isShowButton,
    buttonType,
    progressBarStatus,
    isWagerEnabled,
    countdownTimerTitle,
    isCountdownTimerEnabled,
    bonusDetailsList,
    isActivation,
    bonusName,
    expireTime,
    isReleased,
    isShowWagerButton
  } = bonus;

  return (
    <BonusCard
      bonus={bonus}
      onAccept={acceptFreeSpin}
      isShowButton={isShowButton}
      buttonTitle={t(`web.personaloffice.bonuses.button.${buttonType}`)}
      progressBarStatus={progressBarStatus}
      isWagerEnabled={isWagerEnabled}
      status={freeSpinAggregatedStatusesMap[state]}
      countdownTimerTitle={countdownTimerTitle}
      isCountdownTimerEnabled={isCountdownTimerEnabled}
      openDetails={openDetails}
      isActivation={isActivation}
      detailsList={bonusDetailsList}
      imageUrl={
        imageUrl ||
        `/images/bonuses/${
          isShowMultilangImages ? `${language}/` : ''
        }freespins.png`
      }
      bonusName={bonusName}
      bonusModelId={bonusModelId}
      expireTime={expireTime}
      isRequestProcessing={isRequestProcessing}
      isReleased={isReleased}
      intent={isShowWagerButton ? 'secondary' : 'primary'}
      cardType="freeSpins"
    />
  );
};
